export const WHATSAPP_NUMBER = "919880392340";

export const getWhatsAppLink = (productName) => {
  const message = encodeURIComponent(
    `Hi, I would like to order ${productName} from Mitti Basket.`
  );
  return `https://wa.me/${WHATSAPP_NUMBER}?text=${message}`;
};

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1753055951929-8d7752f28e14?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDV8MHwxfHNlYXJjaHwyfHxtYW5nbyUyMHRyZWUlMjBoYXJ2ZXN0JTIwZnJ1aXR8ZW58MHx8fHwxNzc1NDgyMTk0fDA&ixlib=rb-4.1.0&q=85",
  mangoHero: "https://customer-assets.emergentagent.com/job_village-harvest-28/artifacts/rtdugvp0_Gemini_Generated_Image_q9o288q9o288q9o2.png",
  mangoDetail: "https://images.unsplash.com/photo-1669207334420-66d0e3450283?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzJ8MHwxfHNlYXJjaHw0fHxmcmVzaCUyMG1hbmdvZXMlMjBoYXJ2ZXN0JTIwb3JnYW5pYyUyMGJhc2tldHxlbnwwfHx8fDE3NzU0ODIxODl8MA&ixlib=rb-4.1.0&q=85",
  pantryHero: "https://images.unsplash.com/photo-1705584287412-23c0a5a6d2d5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NjV8MHwxfHNlYXJjaHwzfHx0cmFkaXRpb25hbCUyMGluZGlhbiUyMGNvb2tpbmclMjBjbGF5JTIwcG90fGVufDB8fHx8MTc3NTQ4MjE5NHww&ixlib=rb-4.1.0&q=85",
  festiveHero: "https://images.unsplash.com/photo-1605327047708-e534b2257359?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHwxfHxpbmRpYW4lMjBmZXN0aXZlJTIwc3dlZXRzJTIwcGxhdGUlMjBkaXdhbGl8ZW58MHx8fHwxNzc1NDkwMjAwfDA&ixlib=rb-4.1.0&q=85",
  farmer: "https://images.unsplash.com/photo-1608876537010-ac56d8731614?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHwyfHxpbmRpYW4lMjB2aWxsYWdlJTIwZmFybWVyJTIwcG9ydHJhaXR8ZW58MHx8fHwxNzc1NDgyMTkwfDA&ixlib=rb-4.1.0&q=85",
  subscriptionBox: "https://images.pexels.com/photos/5503186/pexels-photo-5503186.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  heroMango: "https://images.unsplash.com/photo-1669207334420-66d0e3450283?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MjJ8MHwxfHNlYXJjaHwxfHxmcmVzaCUyMG1hbmdvZXMlMjBnb2xkZW4lMjBiYXNrZXQlMjBwcmVtaXVtfGVufDB8fHx8MTc3NTQ4NzM5OXww&ixlib=rb-4.1.0&q=85",
  heroLitchi: "https://images.unsplash.com/photo-1552081586-854725ddbaa8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHwyfHxmcmVzaCUyMGxpdGNoaSUyMGZydWl0JTIwYmFza2V0JTIwb3JnYW5pY3xlbnwwfHx8fDE3NzU0ODMyMTl8MA&ixlib=rb-4.1.0&q=85",
  heroMakhana: "https://images.pexels.com/photos/7051132/pexels-photo-7051132.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  heroGhee: "https://customer-assets.emergentagent.com/job_village-harvest-28/artifacts/lpvi5o77_ChatGPT%20Image%20Apr%207%2C%202026%2C%2006_51_56%20PM.png",
  secretGardenJars: "https://images.unsplash.com/photo-1703792686598-e63c485610dc?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODh8MHwxfHNlYXJjaHwxfHxob25leSUyMGphcnMlMjBhcnRpc2FuJTIwaGFuZG1hZGUlMjB3b29kZW4lMjBzaGVsZnxlbnwwfHx8fDE3NzU1MDM1MzF8MA&ixlib=rb-4.1.0&q=85",
  secretGardenPath: "https://images.unsplash.com/photo-1611660474008-6cfa4523ea16?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzd8MHwxfHNlYXJjaHwxfHxnYXJkZW4lMjBwYXRoJTIwZ3JlZW4lMjBsdXNoJTIwbmF0dXJlfGVufDB8fHx8MTc3NTUwMzUyNHww&ixlib=rb-4.1.0&q=85",
  secretGardenBotanical: "https://images.unsplash.com/photo-1759390304699-5c389476ca80?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzd8MHwxfHNlYXJjaHwyfHxnYXJkZW4lMjBwYXRoJTIwZ3JlZW4lMjBsdXNoJTIwbmF0dXJlfGVufDB8fHx8MTc3NTUwMzUyNHww&ixlib=rb-4.1.0&q=85",
};

export const heroSlides = [
  { image: IMAGES.heroMango, title: "Mangoes", subtitle: "Tree-ripened from heritage orchards", badge: "Summer 2026" },
  { image: IMAGES.heroLitchi, title: "Litchi", subtitle: "Hand-picked from Muzaffarpur", badge: "Limited Season" },
  { image: IMAGES.heroMakhana, title: "Makhana", subtitle: "Hand-popped from Darbhanga", badge: "Superfood" },
  { image: IMAGES.heroGhee, title: "A2 Ghee", subtitle: "Bilona method, village-made", badge: "Artisanal" },
];

/* ─── SEASON HARVEST — No subscription ─── */
export const seasonHarvest = [
  {
    id: "dudhiya-malda-mango",
    name: "Dudhiya Malda Mango",
    tagline: "Creamy white pulp, melt-in-mouth sweetness",
    origin: "Malda, West Bengal",
    basePrice: 1799,
    unit: "5 kg box",
    minQty: 5,
    qtyStep: 5,
    qtyUnit: "kg",
    badge: "Rare Find",
    subscribable: false,
    image: "https://customer-assets.emergentagent.com/job_village-harvest-28/artifacts/u8tcjmmc_WEbeE7RD.jpeg",
  },
  {
    id: "langra-mango",
    name: "Langra Mango",
    tagline: "The king of flavour from Varanasi",
    origin: "Varanasi, UP",
    basePrice: 1799,
    unit: "5 kg box",
    minQty: 5,
    qtyStep: 5,
    qtyUnit: "kg",
    badge: "Best Seller",
    subscribable: false,
    image: "https://customer-assets.emergentagent.com/job_village-harvest-28/artifacts/agzvol5h_HFWnVBpX.jpeg",
  },
  {
    id: "bambai-mango",
    name: "Bambai Mango",
    tagline: "Bihar's prized heritage variety, intensely sweet",
    origin: "Bhagalpur, Bihar",
    basePrice: 1799,
    unit: "5 kg box",
    minQty: 5,
    qtyStep: 5,
    qtyUnit: "kg",
    badge: "Heritage",
    subscribable: false,
    image: "https://images.unsplash.com/photo-1664183238215-0848f923e3dc?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjd8MHwxfHNlYXJjaHwzfHxyaXBlJTIwbWFuZ29lcyUyMGNsb3NlJTIwdXAlMjB0cm9waWNhbCUyMGZydWl0fGVufDB8fHx8MTc3NTQ5NTc0MXww&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "chausa-mango",
    name: "Chausa Mango",
    tagline: "The aromatic late-summer delight",
    origin: "Hajipur, Bihar",
    basePrice: 1799,
    unit: "5 kg box",
    minQty: 5,
    qtyStep: 5,
    qtyUnit: "kg",
    badge: "Aromatic",
    subscribable: false,
    image: "https://images.unsplash.com/photo-1650742031412-24fb827405a7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MjJ8MHwxfHNlYXJjaHwyfHxmcmVzaCUyMG1hbmdvZXMlMjBnb2xkZW4lMjBiYXNrZXQlMjBwcmVtaXVtfGVufDB8fHx8MTc3NTQ4NzM5OXww&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "dashehari-mango",
    name: "Dashehari Mango",
    tagline: "Lucknow's finest, fibreless golden pulp",
    origin: "Lucknow, UP",
    basePrice: 1799,
    unit: "5 kg box",
    minQty: 5,
    qtyStep: 5,
    qtyUnit: "kg",
    badge: "Classic",
    subscribable: false,
    image: "https://images.pexels.com/photos/17482442/pexels-photo-17482442.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    id: "gulabkhas-mango",
    name: "Gulabkhas Mango",
    tagline: "Rose-scented aroma, velvety smooth flesh",
    origin: "Darbhanga, Bihar",
    basePrice: 1799,
    unit: "5 kg box",
    minQty: 5,
    qtyStep: 5,
    qtyUnit: "kg",
    badge: "Limited Edition",
    subscribable: false,
    image: "https://images.unsplash.com/photo-1669207334420-66d0e3450283?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MjJ8MHwxfHNlYXJjaHwxfHxmcmVzaCUyMG1hbmdvZXMlMjBnb2xkZW4lMjBiYXNrZXQlMjBwcmVtaXVtfGVufDB8fHx8MTc3NTQ4NzM5OXww&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "kishen-bhog-mango",
    name: "Kishen Bhog Mango",
    tagline: "Bengal's grand mango, large and luscious",
    origin: "Malda, West Bengal",
    basePrice: 1799,
    unit: "5 kg box",
    minQty: 5,
    qtyStep: 5,
    qtyUnit: "kg",
    badge: "Grand Size",
    subscribable: false,
    image: "https://customer-assets.emergentagent.com/job_village-harvest-28/artifacts/rqigmsc3_41Ey87U8JvS.jpg",
  },
  {
    id: "shahi-litchi",
    name: "Shahi Litchi",
    tagline: "Juicy, sweet, from Muzaffarpur",
    origin: "Muzaffarpur, Bihar",
    basePrice: 699,
    unit: "2 kg box",
    minQty: 2,
    qtyStep: 1,
    qtyUnit: "kg",
    badge: "Seasonal",
    subscribable: false,
    image: "https://images.unsplash.com/photo-1552081586-854725ddbaa8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHwyfHxmcmVzaCUyMGxpdGNoaSUyMGZydWl0JTIwYmFza2V0JTIwb3JnYW5pY3xlbnwwfHx8fDE3NzU0ODMyMTl8MA&ixlib=rb-4.1.0&q=85",
  },
];

/* ─── VILLAGE PANTRY — With subscription ─── */
export const villagePantry = [
  {
    id: "a2-desi-ghee",
    name: "A2 Desi Ghee",
    tagline: "Bilona method, slow-churned from A2 cow milk",
    origin: "Village Kitchens, Bihar",
    basePrice: 2270,
    unit: "1 kg jar",
    minQty: 1,
    qtyStep: 1,
    qtyUnit: "kg",
    badge: "Best Seller",
    subscribable: true,
    image: "https://customer-assets.emergentagent.com/job_village-harvest-28/artifacts/c0j5sz48_ChatGPT%20Image%20Apr%207%2C%202026%2C%2006_45_11%20PM.png",
  },
  {
    id: "premium-makhana",
    name: "Premium Makhana",
    tagline: "Hand-popped, nutrient-rich superfood",
    origin: "Darbhanga, Bihar",
    basePrice: 449,
    unit: "250 gm pack",
    minQty: 250,
    qtyStep: 250,
    qtyUnit: "gm",
    badge: "Superfood",
    subscribable: true,
    image: "https://customer-assets.emergentagent.com/job_village-harvest-28/artifacts/lnfjm7wm_Gemini_Generated_Image_xkokbqxkokbqxkok.png",
  },
  {
    id: "stone-ground-sattu",
    name: "Stone-ground Sattu",
    tagline: "Bihar's original superfood, stone-milled",
    origin: "Village Mills, Bihar",
    basePrice: 799,
    unit: "2 kg pack",
    minQty: 2,
    qtyStep: 2,
    qtyUnit: "kg",
    badge: "Heritage",
    subscribable: true,
    image: "https://customer-assets.emergentagent.com/job_village-harvest-28/artifacts/j7kf4rdw_Gemini_Generated_Image_hqjbhahqjbhahqjb.png",
  },
  {
    id: "toor-dal",
    name: "Toor Dal",
    tagline: "Farm-sourced, unpolished pigeon pea lentils",
    origin: "Small Farms, Bihar",
    basePrice: 400,
    unit: "2 kg pack",
    minQty: 2,
    qtyStep: 2,
    qtyUnit: "kg",
    badge: "Farm Direct",
    subscribable: true,
    image: "https://customer-assets.emergentagent.com/job_village-harvest-28/artifacts/6gb8wj8y_ChatGPT%20Image%20Apr%207%2C%202026%2C%2007_05_03%20PM.png",
  },
  {
    id: "moong-dal",
    name: "Moong Dal",
    tagline: "Split green gram, naturally dried",
    origin: "Small Farms, Eastern India",
    basePrice: 349,
    unit: "2 kg pack",
    minQty: 2,
    qtyStep: 2,
    qtyUnit: "kg",
    badge: "Farm Direct",
    subscribable: true,
    image: "https://customer-assets.emergentagent.com/job_village-harvest-28/artifacts/5pd80lk5_Gemini_Generated_Image_wlu7w9wlu7w9wlu7.png",
  },
  {
    id: "masoor-dal",
    name: "Masoor Dal",
    tagline: "Red lentils, sun-dried and unpolished",
    origin: "Small Farms, Bihar",
    basePrice: 324,
    unit: "2 kg pack",
    minQty: 2,
    qtyStep: 2,
    qtyUnit: "kg",
    badge: "Farm Direct",
    subscribable: true,
    image: "https://customer-assets.emergentagent.com/job_village-harvest-28/artifacts/kbq249s2_Gemini_Generated_Image_ti8rwfti8rwfti8r.png",
  },
  {
    id: "chana-dal",
    name: "Chana Dal",
    tagline: "Split chickpeas, rich and earthy",
    origin: "Small Farms, Eastern India",
    basePrice: 249,
    unit: "2 kg pack",
    minQty: 2,
    qtyStep: 2,
    qtyUnit: "kg",
    badge: "Farm Direct",
    subscribable: true,
    image: "https://customer-assets.emergentagent.com/job_village-harvest-28/artifacts/f129dgj8_ChatGPT%20Image%20Apr%207%2C%202026%2C%2007_01_12%20PM.png",
  },
  {
    id: "cold-pressed-mustard-oil",
    name: "Cold Pressed Mustard Oil",
    tagline: "Traditional kachi ghani, pungent & pure",
    origin: "Village Mills, Bihar",
    basePrice: 999,
    unit: "1 L bottle",
    minQty: 1,
    qtyStep: 1,
    qtyUnit: "L",
    badge: "New",
    subscribable: true,
    image: "https://customer-assets.emergentagent.com/job_village-harvest-28/artifacts/k844vb29_Gemini_Generated_Image_w1v0s2w1v0s2w1v0.png",
  },
];

export const featuredPantry = villagePantry.slice(0, 4);

export const festiveCollection = [
  {
    id: "thekua",
    name: "Thekua",
    tagline: "Chhath Puja's sacred sweet",
    origin: "Bihar Households",
    basePrice: 499,
    unit: "2 kg box",
    minQty: 2,
    qtyStep: 2,
    qtyUnit: "kg",
    badge: "Festive",
    subscribable: false,
    comingSoon: true,
    image: "https://customer-assets.emergentagent.com/job_village-harvest-28/artifacts/9h248u5o_Sudh-Ghee.png",
  },
  {
    id: "tilkut",
    name: "Tilkut",
    tagline: "Gaya's winter delicacy",
    origin: "Gaya, Bihar",
    basePrice: 599,
    unit: "2 kg box",
    minQty: 2,
    qtyStep: 2,
    qtyUnit: "kg",
    badge: "Festive",
    subscribable: false,
    comingSoon: true,
    image: "https://images.unsplash.com/photo-1610529540465-84bd2d3fe3f7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTJ8MHwxfHNlYXJjaHwxfHxzZXNhbWUlMjBiYXIlMjBjYW5keSUyMHRyYWRpdGlvbmFsJTIwc25hY2t8ZW58MHx8fHwxNzc1NDkwMjAwfDA&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "khajur-sweets",
    name: "Khajur Sweets",
    tagline: "Date-palm jaggery confections",
    origin: "Rural Bihar",
    basePrice: 449,
    unit: "2 kg box",
    minQty: 2,
    qtyStep: 2,
    qtyUnit: "kg",
    badge: "Festive",
    subscribable: false,
    comingSoon: true,
    image: "https://images.unsplash.com/photo-1745582763219-1a5259056ba3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTV8MHwxfHNlYXJjaHwxfHxpbmRpYW4lMjBqYWdnZXJ5JTIwc3dlZXRzJTIwdHJhZGl0aW9uYWx8ZW58MHx8fHwxNzc1NDkwMTkwfDA&ixlib=rb-4.1.0&q=85",
  },
];

/* Testimonials data */
export const testimonials = [
  { quote: "The ghee reminded me of what we had in our village growing up. Pure gold.", name: "Priya M.", city: "Bangalore" },
  { quote: "Best mangoes I've ever had in Bangalore. My family finished the entire box in two days.", name: "Arjun S.", city: "Bangalore" },
  { quote: "The makhana is so fresh and crunchy. My kids ask for it as a snack every evening now.", name: "Meera K.", city: "Bangalore" },
  { quote: "Finally found sattu that tastes exactly like the one from back home. Incredible quality.", name: "Ravi P.", city: "Bangalore" },
  { quote: "The dals cook so differently. You can taste the difference when it's unpolished and real.", name: "Anita D.", city: "Bangalore" },
];

/* ─── SECRET GARDEN BOX ─── */
export const secretGardenBox = {
  id: "secret-garden-box",
  name: "The Secret Garden Box",
  tagline: "Seven treasures. One seasonal mystery.",
  origin: "Mitti Basket Curation",
  basePrice: 2599,
  unit: "box",
  minQty: 1,
  qtyStep: 1,
  qtyUnit: "box",
  badge: "Exclusive",
  subscribable: true,
  image: "https://customer-assets.emergentagent.com/job_village-harvest-28/artifacts/djkihpsx_Gemini_Generated_Image_re3u47re3u47re3u.png",
};

/* Legacy summerHarvest for sub-pages */
export const summerHarvest = seasonHarvest;
